import { DropdownMenu as BSDropdownMenu } from 'react-bootstrap'
import type { DropdownMenuProps } from 'react-bootstrap'

/**
 * Wrapper around Bootstrap's DropdownMenu that defaults to `strategy: 'fixed'`
 * so the menu is never clipped by overflow-auto/overflow-hidden ancestors (e.g. DataTable).
 */
export function DropdownMenu({ popperConfig, ...props }: DropdownMenuProps) {
    return <BSDropdownMenu popperConfig={{ ...popperConfig }} {...props} />
}
